$(document).on("turbolinks:load", () => {
    
    $('#modal-open').on('click',function(){
        $('.js-modal').fadeIn();
        return false;
    });
    $('#modal-close').on('click',function(){
        $('.js-modal').fadeOut();
        return false;
    });

})
